import React, { Component } from 'react';
import './demoFormPage.css';
import saveScheduleApi from '../../networking/apis/scheduleDemo';
import EulaForm from '../eulaForm/eulaform';
import { emailWarning, isRestrictedDomain } from '../../utils/utils';
import DOMPurify from 'dompurify';

export interface DemoFormType {
    name: string;
    email: string;
    companyName: string;
    message: string;
}

interface DemoFormStateType {
    name: string;
    email: string;
    companyName: string;
    message: string;
    isEulaAccepted: boolean;
    showEula: boolean;
    showAlert: boolean;
    alertMessage: string;
    alertType: 'warning' | 'confirmation';
}

class DemoFormPage extends Component<{}, DemoFormStateType> {
    constructor(props: {}) {
        super(props);
        this.state = {
            name: '',
            email: '',
            companyName: '',
            message: '',
            isEulaAccepted: false,
            showEula: false,
            showAlert: false,
            alertMessage: '',
            alertType: 'warning'
        };
    }
    
    handleChange = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => { 
        let { name, value } = e.target;
        value = DOMPurify.sanitize(value);
        this.setState({ [name]: value } as Pick<DemoFormType, keyof DemoFormType>);
    };

    toggleEulaPopup = () => {
      this.setState({ showEula: !this.state.showEula });
    };
    
    handleEulaAccept = () => {
        this.setState({ isEulaAccepted: true, showEula: false });
      };

    handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const { name, email, companyName, message, isEulaAccepted } = this.state;
        if (!name || !email|| !companyName) {
            this.showAlert('Please fill out all fields');
        } else if(isRestrictedDomain(email)) {
            this.showAlert(emailWarning, "warning");
        } else {
            if (isEulaAccepted) {
                const userData= { name, email, companyName, message }
                const save = await saveScheduleApi(userData) // save to db
                
                if (save?.status) {
                    this.showAlert(`You have successfully submitted a demo request. Check your mail for more details`, "confirmation");
                } else {
                    const error = save?.error?.error ? save?.error?.error : save?.error
                    this.showAlert(error, "warning");
                }
            } else {
                this.showAlert('You must accept the EULA to proceed');
            }
        }
    };

    showAlert = (message: string, type: DemoFormStateType["alertType"] = 'warning') => {
      this.setState({ showAlert: true, alertMessage: message, alertType: type  });
      
      setTimeout(() => {
        this.setState({ showAlert: false, alertMessage: '', alertType: type });
      }, 2000); 
    };

    render() {
        const { isEulaAccepted, showEula, name, email, companyName, message, showAlert, alertMessage, alertType } = this.state;
        return (
            <div>
                <div className="form-page">
                    <div className='form-box'>
                        <h2>Contact Us for a demo</h2>
                        <form className="form-container" onSubmit={this.handleSubmit}>
                            <div>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={name}
                                    placeholder="Name"
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={email}
                                    placeholder="Email"
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div>
                                <input
                                    type="text"
                                    id="companyName"
                                    name="companyName"
                                    value={companyName}
                                    placeholder="Company Name"
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div>
                                <textarea
                                    placeholder="Notes.."
                                    id="message"
                                    name="message"
                                    value={message}
                                    onChange={this.handleChange}
                                    maxLength={250}
                                    rows={2}
                                />
                            </div>
                            <div>
                                <button type="button" onClick={this.toggleEulaPopup}>
                                    Read and Accept End-User License Agreement (EULA)
                                </button>
                            </div>
                            <button type="submit">Submit</button>
                        </form>
                    </div>
                </div>
                {showEula && (
                    <div className="popup">
                        <div className="popup-inner">
                            <button className="close-button" onClick={this.toggleEulaPopup}>×</button>
                            <EulaForm isEulaAccepted={isEulaAccepted} onAccept={this.handleEulaAccept} />
                        </div>
                    </div>
                )}

                {showAlert && (
                    <div className={`alert-popup ${showAlert ? 'show' : ''} `}>
                        <div className={`alert-inner ${alertType}`}>
                            <p>{alertMessage}</p>
                        </div>
                    </div>
                )}
            </div>
            
        );
    }
}

export default DemoFormPage;